import { render, staticRenderFns } from "./SearchCourses.vue?vue&type=template&id=4646ce02"
import script from "./SearchCourses.vue?vue&type=script&lang=js"
export * from "./SearchCourses.vue?vue&type=script&lang=js"
import style0 from "./SearchCourses.vue?vue&type=style&index=0&id=4646ce02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports